/* eslint-disable */
import React from 'react';
import {actions} from 'react-redux-form';
import {toast} from 'react-toastify';
import irelandApi from '../irelandApi';
import store, {history} from '../store';
import ToastMessage from '../components/common/toast-message';
import {destandard, convertToFormData, removeNullFieldsFromJson} from '../utils/commonFunctions';
import {GET_HOMEPAGES_REJECTED, GET_HOMEPAGES_FULFILLED, GET_HOMEPAGES_PENDING} from '../reducers/homePagesReducer';
import { UI_REP_HOME_PAGE, API_RETAILER_HOME_PAGE, API_REP_HOME_PAGE, PRELOGIN_HOME_PAGE } from '../data/homePageTypes';

export const getHomePage = () => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_CAROUSELS_PENDING'});
  dispatch({type: 'GET_HOMEPAGE_TILES_PENDING'});
  return irelandApi.get('/api/retailer/home_page')
    .then((response) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_FULFILLED', payLoad: {data: response.data.data.attributes.carousel}});
      dispatch({type: 'GET_HOMEPAGE_TILES_FULFILLED', payLoad: {data: response.data.data.attributes.tiles}});
    })
    .catch(() => {
    });
};

export const getRepHomePage = () => (dispatch) => {
  dispatch({type: 'GET_REP_HOMEPAGE_CAROUSELS_PENDING'});
  dispatch({type: 'GET_REP_HOMEPAGE_TILES_PENDING'});
  return irelandApi.get('/api/rep/home_page')
    .then((response) => {
      dispatch({type: 'GET_REP_HOMEPAGE_CAROUSELS_FULFILLED', payLoad: {data: response.data.data.attributes.carousel}});
      dispatch({type: 'GET_REP_HOMEPAGE_TILES_FULFILLED', payLoad: {data: response.data.data.attributes.tiles}});
    })
    .catch(() => {
    });
};

export const getPreLoginHomePage = () => (dispatch) => {
  dispatch({type: 'GET_PRELOGIN_HOMEPAGE_CAROUSELS_PENDING'});
  dispatch({type: 'GET_PRELOGIN_HOMEPAGE_TILES_PENDING'});
  return irelandApi.get('/api/pre_login/home_page')
    .then((response) => {
      dispatch({type: 'GET_PRELOGIN_HOMEPAGE_CAROUSELS_FULFILLED', payLoad: {data: response.data.data.attributes.carousel}});
      dispatch({type: 'GET_PRELOGIN_HOMEPAGE_TILES_FULFILLED', payLoad: {data: response.data.data.attributes.tiles}});
    })
    .catch(() => {
    });
};

export const getHomePages = () => dispatch => {
  dispatch({type: GET_HOMEPAGES_PENDING});
  return irelandApi.get('/api/admin/home_pages')
    .then((response) => {
      dispatch({type: GET_HOMEPAGES_FULFILLED, payLoad: {data: response.data.data}});
    })
    .catch(() => {
      dispatch({type: GET_HOMEPAGES_REJECTED});
    });
};

export const getCarousels = () => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_CAROUSELS_PENDING'});
  return irelandApi.get('/api/admin/home_page_carousel/retailer_index')
    .then((response) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_REJECTED', payLoad: error.data});
    });
};

export const updateCarousels = (payload) => {
  const data = {
    home_page_carousel: {...payload}
  };
  return irelandApi.patch('/api/admin/home_page_carousel/change_position', data)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousels has been saved successfully"/>);
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      for (const p in data) {
        if (data.hasOwnProperty(p)) {
          toast.success(<ToastMessage iconStyle="error" message={data[p]}/>);
        }
      }
    });
};

export const updateCarousel = (id, payLoad, homePageType) => {
  const formData = prepareCarousalPayload(payLoad, homePageType);

  return irelandApi.patch(`/api/admin/home_page_carousel/${id}`, formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousel has been updated successfully"/>);
      history.push(`/admin/homepages/${homePageType}#carousel`);
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      for (const p in data) {
        if (data.hasOwnProperty(p)) {
          toast.success(<ToastMessage iconStyle="error" message={`${p} : ${data[p]}`}/>);
        }
      }
    });
};

export const createCarousel = (payLoad, homePageType) => {
  const formData = prepareCarousalPayload(payLoad, homePageType);

  return irelandApi.post('/api/admin/home_page_carousel', formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousel has been created successfully"/>);
      history.push(`/admin/homepages/${homePageType}#carousel`);
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      for (const p in data) {
        if (data.hasOwnProperty(p)) {
          toast.success(<ToastMessage iconStyle="error" message={`${p} : ${data[p]}`}/>);
        }
      }
    });
};

export const deleteCarousel = id => (dispatch) => {
  dispatch({type: 'DELETE_CAROUSEL_PENDING'});
  return irelandApi.delete(`/api/admin/home_page_carousel/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousel has been deleted successfully"/>);
      dispatch({type: 'DELETE_CAROUSEL_FULFILLED', payLoad: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during delete Carousel"/>);
      dispatch({type: 'DELETE_CAROUSEL_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

export const getCarousel = id => (dispatch) => {
  dispatch({type: 'GET_CAROUSEL_PENDING'});
  return irelandApi.get(`/api/admin/home_page_carousel/${id}`)
    .then((response) => {
      dispatch({type: 'GET_CAROUSEL_META_FULFILLED', payLoad: response.data.meta});
      if (parseInt(id)) {
        const data = destandard({
          ...response.data.data.attributes
        });
        data.permission_ids = {};
        data.permissions.map((perm) => {
          perm.children.map((child) => {
            if (child.checked) {
              const element = {};
              element.checked = true;
              data.permission_ids[child.id] = element;
            }
          });
        });
        if (data.button_link.match(/^\/articles\/\d+$/)) {
          const arr = data.button_link.split('/');
          data.button_article_link = arr[arr.length - 1];
        }
        store.dispatch(actions.load('deep.home_page_carousel', data));
        dispatch({type: 'GET_CAROUSEL_FULFILLED', payLoad: data});  
      }
    })
    .catch((error) => {
      toast.warn(<ToastMessage iconStyle="warning"
                               message={'Unable to get carousel.'}/>, {autoClose: 2000});
      dispatch({type: 'GET_CAROUSEL_REJECTED', payLoad: 'error'});
    });
};

export const getTiles = (type) => (dispatch) => {
  const url = {
    representatives: '/api/admin/homepage_tile/rep_index',
    retailers: '/api/admin/homepage_tile/retailer_index',
    pre_login: '/api/admin/homepage_tile/pre_login_index',
  };
  dispatch({type: 'GET_HOMEPAGE_TILES_PENDING'});
  return irelandApi
    .get(url[type])
    .then((response) => {
      dispatch({type: 'GET_HOMEPAGE_TILES_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_HOMEPAGE_TILES_REJECTED', payLoad: error.data});
    });
};

export const getTile = id => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_TILE_PENDING'});
  return irelandApi
    .get(`/api/admin/homepage_tile/${id}`)
    .then((response) => {
      const attributes = response.data.data.attributes;
      dispatch(actions.load('deep.tile', {
        link: attributes['button-link'],
        label: attributes['button-label'],
        button_color: attributes['button-color'],
        button_text_color_when_hover: attributes['button-text-color-when-hover'],
      }));
      dispatch({type: 'GET_HOMEPAGE_TILE_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_HOMEPAGE_TILE_REJECTED', payLoad: error.data});
    });
};

export const updateTiles = (payLoad, id, kind, redirectUrl, homePageType) => {
  const formData = new FormData();
  let tile;
  if (kind === 'static') {
    tile = {};
    if (payLoad.image !== undefined) { tile.image = payLoad.image; }
    tile.button_color = payLoad.button_color;
    tile.button_text_color_when_hover = payLoad.button_text_color_when_hover;
    if (homePageType === 'pre_login') {
      tile.button_label = payLoad.label
      tile.button_link = payLoad.link
    }
  } else {
    tile = payLoad;
  }
  Object
    .keys(tile)
    .forEach((key) => {
      if (key !== 'label' && key !== 'link') {
        formData.append(`homepage_tile[${key}]`, tile[key]);
      }
    });
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  return irelandApi
    .patch(`/api/admin/homepage_tile/${id}`, formData, config)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Tile has been saved successfully"/>);
      history.push(redirectUrl);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save tile"/>);
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

export const getGroups = () => (dispatch) => {
  dispatch({ type: "GET_GROUPS_LIST_PENDING" });

  return irelandApi.get(`/api/admin/home_page_carousel/new`)
    .then((response) => {
      dispatch({ type: "GET_GROUPS_LIST_FULFILLED", payLoad: response.data.meta });
    })
    .catch((error) => {
      dispatch({ type: 'GET_GROUPS_LIST_REJECTED', payLoad: error.data })
    })
};

const prepareCarousalPayload = (payLoad, homePageType) => {
  let carousalData = removeNullFieldsFromJson(payLoad);

  const permissions = Object.keys(carousalData.permission_ids).filter(p => carousalData.permission_ids[p].checked);

  let newHomePageType;
  if (homePageType === UI_REP_HOME_PAGE) {
    newHomePageType = API_REP_HOME_PAGE;
  } else if (homePageType === PRELOGIN_HOME_PAGE) {
    newHomePageType = PRELOGIN_HOME_PAGE;
  } else {
    newHomePageType = API_RETAILER_HOME_PAGE;
  }
  carousalData = {
    ...payLoad,
    home_page_type: newHomePageType,
    group_ids: carousalData.group_ids.map(curr => curr.value) || [],
    permission_ids: permissions
  };

  if (carousalData.button_article_link > 0) {
    carousalData["button_link"] = "/articles/" + carousalData.button_article_link;
  }

  delete carousalData.permissions;

  if (carousalData["group_ids"].includes("all")) {
    carousalData["all_groups"] = true;
    delete carousalData["group_ids"];
  }

  if (carousalData["group_ids"] && carousalData["group_ids"].length === 0) {
    carousalData["all_groups"] = false;
    carousalData["group_ids"] = [];
  }

  const formData = convertToFormData('home_page_carousel', carousalData);

  return formData;
};



// WEBPACK FOOTER //
// ./src/actions/home.js